import { c as _c } from "react/compiler-runtime";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { WatchlistQueryParams, ApiSuccessResponse, AddToWatchlistPayload, AddToWatchlistResponse } from "@/types/watchlist";
import { addToWatchlist, getWatchlist } from "@/services/watchlist";
export const useWatchlist = params => {
  const $ = _c(2);
  let t0;
  if ($[0] !== params) {
    t0 = {
      queryKey: ["watchlist", params],
      queryFn: () => getWatchlist(params)
    };
    $[0] = params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useQuery(t0);
};
export const useIsInWatchlist = uuid => {
  const $ = _c(5);
  const {
    data
  } = useWatchlist();
  if (!uuid || !data?.data?.items) {
    return false;
  }
  let t0;
  if ($[0] !== data.data.items || $[1] !== uuid) {
    let t1;
    if ($[3] !== uuid) {
      t1 = item => item?.uuid === uuid;
      $[3] = uuid;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    t0 = data.data.items.some(t1);
    $[0] = data.data.items;
    $[1] = uuid;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
export const useAddToWatchlist = () => {
  const $ = _c(2);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== queryClient) {
    t0 = {
      mutationFn: addToWatchlist,
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ["watchlist"]
        });
      }
    };
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
};